// @ts-nocheck

import { IMessage } from 'src/shared/types/Document';
import { WebSocketClient, getAccessToken } from './WebsocketClient';
import { sha512 } from 'js-sha512';

export const NotificationServiceName = 'Notification';
export const NotificationTypes = {
  Error: 'Error',
  Subscription: 'Subscription',
};

export const NotificationActions = {
  Subscribe: 'Subscribe',
  Unsubscribe: 'Unsubscribe',
  Ping: 'Ping',
};

export const WebsocketNotificationService = {
  isInitialized: false,
  lastConnectionId: '',
  subscriptions: [],

  initialize() {
    if (this.isInitialized) {
      return;
    }

    this.isInitialized = true;
    WebSocketClient.subscribe((message) => {
      this.subscriptions.forEach((subscription) => {
        const isUniqueHandlersEqual = message.uniqueHandler === subscription.message.uniqueHandler;
        const isTopicsEqual = message.topic === subscription.message.topic;
        if (isTopicsEqual && (message.isPublic || isUniqueHandlersEqual)) {
          subscription.callback(message);
        }
      });
    });
  },

  async refreshSubscriptions() {
    await WebSocketClient.connect();
    const currentConnectionId = WebSocketClient.connectionId;
    if (currentConnectionId !== this.lastConnectionId) {
      this.lastConnectionId = currentConnectionId;
      this.subscriptions.forEach((subscription) => WebSocketClient.send(subscription.message));
    }
  },

  async subscribe(topic: string, uniqueHandler: string, callback) {
    await this.refreshSubscriptions();
    const subscriptionMessage = {
      topic,
      service: NotificationServiceName,
      action: NotificationActions.Subscribe,
      accessToken: getAccessToken(),
      uniqueHandler,
    };
    this.subscriptions.push({
      callback,
      message: subscriptionMessage,
      uniqueHandler: subscriptionMessage.uniqueHandler,
    });
    await WebSocketClient.send(subscriptionMessage);
  },

  unsubscribe(uniqueHandler: string) {
    this.subscriptions = this.subscriptions.filter((subscription) => subscription.uniqueHandler !== uniqueHandler);
    return WebSocketClient.send({
      uniqueHandler,
      service: NotificationServiceName,
      action: NotificationActions.Unsubscribe,
    });
  },

  async WaitOnceAndThen(topic: string, $promise) {
    const uniqueHandler = sha512(topic + new Date());
    await this.subscribe(topic, uniqueHandler, (notification) => {
      $promise.resolve(notification);
      this.unsubscribe(uniqueHandler);
    });
  },

  async subscribeOnce(topic, callback) {
    const uniqueHandler = sha512(topic + new Date());
    await this.subscribe(topic, uniqueHandler, (notification) => {
      callback(notification);
      this.unsubscribe(uniqueHandler);
    });
  },

  listenTo(topic) {
    return new Promise<IMessage>((resolve, reject) => {
      this.subscribeOnce(topic, resolve).catch(reject);
    });
  },
};

WebsocketNotificationService.initialize();
